import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext, useField } from 'formik';
import DateFnUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { format } from 'date-fns';

function DateField({ name, label, required, disabled, ...props }) {
  const { isSubmitting } = useFormikContext();
  const [field, meta, { setValue }] = useField(name);

  const fieldError = meta.error;
  const showError = !!fieldError;

  return (
    <MuiPickersUtilsProvider utils={DateFnUtils}>
      <DatePicker
        fullWidth
        // clearable
        required={required}
        allowKeyboardControl={true}
        format="yyyy-MM-dd"
        label={label}
        views={['date']}
        disabled={disabled || isSubmitting}
        inputVariant="outlined"
        {...field}
        {...props}
        selected={(field.value && new Date(field.value)) || null}
        onChange={(val) => {
          setValue(format(val, 'yyyy-MM-dd'));
        }}
        error={showError}
        helperText={fieldError}
      />
    </MuiPickersUtilsProvider>
  );
}

DateField.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
};

export default DateField;
